const imageCompare = $('.image-compare__content__images');

$(imageCompare)
  .on('mousedown', function (e) {
    $(this).mousemove(function (e) {
      const leftOffset = e.pageX - $(this).offset().left;
      $(this).find('.img-2').css('left', leftOffset);
    });
  })
  .on('mouseup mouseleave', function () {
    $(this).off('mousemove');
  });

$(imageCompare)
  .on('touchstart touchmove', function (e) {
    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
    let leftOffset = touch.pageX - $(this).offset().left;
    if (leftOffset <= 0) leftOffset = 0;
    if (leftOffset > $(this).outerWidth()) leftOffset = $(this).outerWidth();

    $(this).find('.img-2').css('left', leftOffset);
  })
  .on('touchend', function () {
    $(this).off('mousemove');
  });
